import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Welcome to Yolani's Photoshoot</h1>
          <p>Where we create great memories for families and friends.</p>
          <div className="hero-buttons">
            <button className="btn" onClick={() => document.getElementById('packages').scrollIntoView({ behavior: 'smooth' })}>
              View Packages
            </button>
            <button className="btn btn-secondary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              Book Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;